// Lightweight per-device unread tracking using localStorage.
// scope: 'cust' (customer) or 'adm' (admin). mySide: which sender_type is "me".

const seenKey = (scope, id) => `${scope}_seen_${id}`;

export const isUnread = (scope, inq, mySide) => {
  if (!inq || !inq.last_message_sender) return false;
  if (inq.last_message_sender === mySide) return false; // last message is mine
  const seen = localStorage.getItem(seenKey(scope, inq.id));
  return seen !== (inq.last_activity || '');
};

export const markSeen = (scope, id, lastActivity) => {
  try { localStorage.setItem(seenKey(scope, id), lastActivity || ''); } catch { /* ignore */ }
};

export const countUnread = (scope, inquiries, mySide) =>
  (inquiries || []).filter((i) => isUnread(scope, i, mySide)).length;
